import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BalanceQuery, config, PointsTransferService, PointsTransferType, PartnerQuery, Partner } from '@fgb/core';
import { Subscription, Observable } from 'rxjs';

@Component({
  selector: 'fgb-points-transfer',
  templateUrl: './points-transfer.component.html',
  styleUrls: ['./points-transfer.component.scss'],
})
export class PointsTransferComponent implements OnInit, OnDestroy {
  transferPointsForm: UntypedFormGroup;
  selectedPointsTransferType: PointsTransferType = PointsTransferType.Partner;
  PointsTransferTypes: PointsTransferType[] = [PointsTransferType.Partner, PointsTransferType.NonPartner];
  balanceSub: Subscription;
  partners$: Observable<Partner[]>;
  amount: number = 10;
  balance: number;
  transferMessageKey: string = '';
  transferSuccess: boolean = false;
  private messageTimeout: ReturnType<typeof setTimeout>;
  private readonly messageDuration = 10000;

  @ViewChild('confirmModal') confirmModalRef: ElementRef;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private balanceQuery: BalanceQuery,
    private pointsTransferService: PointsTransferService,
    private partnerQuery: PartnerQuery,
  ) { }

  ngOnInit() {
    this.transferPointsForm = this.formBuilder.group({
      Amount: ['', [Validators.required]],
      partnerSelected: [null, [Validators.required]],
    });
    this.partners$ = this.partnerQuery.selectAll();
    this.transferPointsForm.controls.Amount.setValue(this.amount.toString());
    this.balanceSub = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty).subscribe((bal) => {
      this.balance = bal ?? 0;
    });
  }

  ngOnDestroy() {
    if (this.balanceSub) {
      this.balanceSub.unsubscribe();
    }
    clearTimeout(this.messageTimeout);
  }

  get isFormInvalid() {
    return this.transferPointsForm.invalid;
  }

  selectPartner(partner: Partner) {
    this.transferPointsForm.controls.partnerSelected.setValue(partner);
  }

  send() {
    if (!this.transferPointsForm.valid) {
      return;
    }
    this.transferMessageKey = '';
    this.transferPointsForm.controls.Amount.setValue(this.amount);
    this.modalService.open(this.confirmModalRef, { centered: true });
  }

  transferPoints() {
    let accountNumber = this.transferPointsForm.controls.partnerSelected.value.ExternalRefNumber;
    let amountToTransfer = this.transferPointsForm.controls.Amount.value;
    this.pointsTransferService
      .pointsTransfer(amountToTransfer, accountNumber)
      .toPromise()
      .then((response) => {
        this.modalService.dismissAll();
        this.transferPointsForm.controls.partnerSelected.setValue(null);
        this.amount = 10;
        this.transferPointsForm.controls.Amount.setValue(this.amount.toString());
        this.showTransferMessage(true, 'point.transfer.success.message');
      })
      .catch((err) => {
        this.modalService.dismissAll();
        this.showTransferMessage(false, 'point.transfer.failed.message');
      });
  }

  private showTransferMessage(success: boolean, messageKey: string) {
    clearTimeout(this.messageTimeout);
    this.transferSuccess = success;
    this.transferMessageKey = messageKey;
    this.messageTimeout = setTimeout(() => {
      this.transferMessageKey = '';
    }, this.messageDuration);
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
